import type { Template as TemplateValue } from '@ztechapps/common.contract'
import { Modal as ModalWebUi, ModalDragHandle } from '@ztechapps/webui.modal'
import { Modal } from 'react-bootstrap'
import { QueryTemplateDisplayValue, Template } from '@ztechapps/webui.data-tools'
import React from 'react'
import { SaveCancelButtons } from '@ztechapps/webui.button'

export type OpenTemplateModalProps = {
  category?: string
  filterCategory?: string
  onApply?: (args: { template: TemplateValue }) => void
  onClose?: () => void
  show: boolean
  container?: HTMLElement
}

export const OpenTemplateModal = ({
  category,
  filterCategory,
  onApply,
  onClose,
  show,
  container,
}: OpenTemplateModalProps) => {
  const templateComponents = {
    TemplateDisplayValue: QueryTemplateDisplayValue,
  }
  const [activeTemplate, setActiveTemplate] = React.useState(null)
  const onApplyFilter = (toggleShowModal) => () => {
    onApply?.({ template: activeTemplate })
    onClose?.()
    toggleShowModal()
  }
  const onCancel = (toggleShowModal) => () => {
    onClose?.()
    toggleShowModal()
  }

  return (
    <ModalWebUi show={show} onHide={onClose} trigger={() => null} container={container}>
      {({ toggleShowModal }) => (
        <>
          <ModalDragHandle>Pivot Templates</ModalDragHandle>
          <Modal.Body>
            <Template
              canAdd={false}
              canSetDefault
              canLinkFilterTemplate
              components={templateComponents}
              onChange={setActiveTemplate}
              height={50}
              category={category}
              filterCategory={filterCategory}
            />
          </Modal.Body>
          <Modal.Footer>
            <SaveCancelButtons
              saveText="Use Template"
              saveBusyText="Applying template..."
              onSave={onApplyFilter(toggleShowModal)}
              onCancel={onCancel(toggleShowModal)}
              disabled={!activeTemplate}
            />
          </Modal.Footer>
        </>
      )}
    </ModalWebUi>
  )
}
